import React, { useState } from "react";
import { Button, Modal, CloseButton } from "react-bootstrap";
import iconWallet from '../assets/images/icon-wallet.png';
import iconAdaSwap from '../assets/images/icon-adaswap.png';
import iconEthereum from '../assets/images/icon-ethereum.png';
import iconBinance from '../assets/images/icon-bsc.png';
import iconPolygon from '../assets/images/icon-polygon.png';
import iconDaedalus from '../assets/images/icon-daedalus.png';
import iconWeb3 from '../assets/images/icon-web3.png';
import iconWalletConnect from '../assets/images/icon-wallet-connect.png';
import iconVenly from '../assets/images/icon-venly.png'
import iconPortis from '../assets/images/icon-portis.png';
import iconMew from '../assets/images/icon-mew.png';
import iconCoinbase from '../assets/images/icon-coin-base.png';
import iconLedger from '../assets/images/icon-ledger.png';


import "./ConnectModal.css";

function ConnectModal() {
const [show, setShow] = useState(false);

const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
return (
		<div className="model-wraper">
			<Button className="btn-connect-wallet transition" onClick={handleShow}>
				<span className="d-none d-xl-block">Connect Wallet</span>
				<span className="d-block d-xl-none">
					<img className="img-fluid" src={iconWallet} alt="" />
				</span>
			</Button>
			<Modal show={show} onHide={handleClose} className="wallet-connect-modal" centered>
				<Modal.Header>
					<h2>Connect Wallet</h2>
					<CloseButton variant="white" onClick={handleClose} />
				</Modal.Header>
				<Modal.Body>
					<h3 className="text-center position-relative mb-4 mb-lg-5"><span className="d-inline-block align-top">Choose Network</span></h3>
					<ul className="text-center list-unstyled icons-list mb-3 mb-lg-4">
						<li className="d-inline-block align-top cur-poi active">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconAdaSwap} alt="" />
							</div>
							<span className="icon-name d-block text-center">AdaSwap</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconEthereum} alt="" />
							</div>
							<span className="icon-name d-block text-center">Cardano</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconBinance} alt="" />
							</div>
							<span className="icon-name d-block text-center">Binance</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconPolygon} alt="" />
							</div>
							<span className="icon-name d-block text-center">Polygon</span>
						</li>
					</ul>
					<h3 className="text-center position-relative mb-4 mb-lg-5"><span className="d-inline-block align-top">Choose Wallet</span></h3>
					<ul className="list-unstyled icons-list mb-3 mb-lg-4">
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconDaedalus} alt="" />
							</div>
							<span className="icon-name d-block text-center">Daedalus</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconWeb3} alt="" />
							</div>
							<span className="icon-name d-block text-center">Web3</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconWalletConnect} alt="" />
							</div>
							<span className="icon-name d-block text-center">Wallet Connect</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconVenly} alt="" />
							</div>
							<span className="icon-name d-block text-center">Venly</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconPortis} alt="" />
							</div>
							<span className="icon-name d-block text-center">Portis</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconMew} alt="" />
							</div>
							<span className="icon-name d-block text-center">Mew</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconCoinbase} alt="" />
							</div>
							<span className="icon-name d-block text-center">Coinbase</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconPortis} alt="" />
							</div>
							<span className="icon-name d-block text-center">Portis</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconLedger} alt="" />
							</div>
							<span className="icon-name d-block text-center">ledger</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconPortis} alt="" />
							</div>
							<span className="icon-name d-block text-center">Portis</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconMew} alt="" />
							</div>
							<span className="icon-name d-block text-center">Mew</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconCoinbase} alt="" />
							</div>
							<span className="icon-name d-block text-center">Coinbase</span>
						</li>
						<li className="d-inline-block align-top cur-poi">
							<div className="icon-holder mb-3">
								<img className="img-fluid" src={iconPortis} alt="" />
							</div>
							<span className="icon-name d-block text-center">Portis</span>
						</li>
					</ul>
				</Modal.Body>
			</Modal>
		</div>
	);
}

export default ConnectModal;
